/* @flow */

import React from 'react';
import type { QueryProps } from 'react-apollo';

import { smoothScrollTo } from '../../../../lib/smooth-scroll';
import Card from '../../../card/index';
import Event from '../../event/index';
import EventTabs from './tabs';
import LoadingEvents from '../../loading-events/index';
import EventsFooter from '../../events-footer/index';

import style from './index-module.css';

type Props = {
  data: ProfilePastEventsQuery & ProfileQuery & QueryProps,
  currentUser: Object,
  locale: string,
  intl: IntlShape,
  currentPage: number,
  changePage: Function,
  showingUpcomingEvents: boolean,
  showingPastEvents: boolean
};

const Events: Function = (props: Props): React$Element<*> => {
  const { data: { profile, profilePastEvents }, locale, intl, currentUser, changePage, currentPage } = props;

  const list = profilePastEvents.hosted && profilePastEvents.hosted.nodes.map((event) => {
    return <Event
      key={event.id}
      data={{ event }}
      locale={locale}
      intl={intl}
      hideButton={true}
      pastEvent={true}
    />;
  });
  const changePageAndScroll = (payload) => {
    changePage(payload);
    smoothScrollTo(`.${style.list}`);
  };

  return (
    <Card className={style.list}>
      {list}
      <EventsFooter
        profile={profile}
        currentUser={currentUser}
        events={profilePastEvents.hosted && profilePastEvents.hosted.nodes}
        currentPage={currentPage}
        totalCount={profilePastEvents.hosted && profilePastEvents.hosted.totalCount}
        changePage={changePageAndScroll}
      />
    </Card>
  );
};

const PastEvents: Function = (props: Props): React$Element<*> => {
  const { data: { profilePastEvents }} = props;
  let events;

  if (props.data.loading || props.data.error || !profilePastEvents.hosted) {
    events = <LoadingEvents />;
  }
  else {
    events = <Events {...props} />;
  }

  return <div>
    <EventTabs {...props} />
    {events}
  </div>;
};

export default PastEvents;



// WEBPACK FOOTER //
// ./src/components/profile/events/layouts/past.js